module.exports = __webpack_public_path__ + "04_bob_gold.8fe36e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/04_bob_gold.png
// module id = c/07
// module chunks = 0